<template>

    <div class="home" style="min-height: 150px">

        <div class="wrapper text text--align-center">

            <h2 class="margin margin--bottom-10">Energie vom Feinsten</h2>
            <p class="margin margin--bottom-20">
                Original Bündnerfleisch <br>
                40% Protein, 4% Fett
            </p>
            <div class="remove-padding">
                <img class="start-image" src="../assets/cover.png"/>
            </div>

            <p class="text text--red margin margin--bottom-20">Jetzt gratis eine exklusive Packung <br>
                Original Bündnerfleisch erspielen.</p>
            <router-link to="/selection" class="button margin margin--bottom-10 text text--uppercase">
                Mitmachen
            </router-link>
        </div>

        <!--<md-progress-spinner md-mode="indeterminate"  class="product-loader"/>-->

    </div>
</template>

<style lang="scss">
    @import '../../sass/views/home';
    .home {
        margin-top: 10px;
    }
    .home .start-image {
        margin-bottom: 2em;
    }
</style>
<script>

    import config from '../assets/data/config.json';
    import axios from 'axios';

    export default {
        name: 'Home',

        data: function(){
            return {
                stock: false,
                availableData:  {
                    yoga: {
                        availableCount: 0
                    },
                    workout: {
                        availableCount: 0
                    },
                    running: {
                        availableCount: 0
                    }
                }
            }
        },
        mounted: function(){

            axios.get(config.endpoint.available).then(response => {

                if(response.data.availableData){
                    this.availableData = response.data.availableData;
                }

                this.checkAvailableProducts();


            }).catch((e) => {

            });

        },
        methods: {

            checkAvailableProducts: function () {

//                const allProducts = this.availableData;
//                const emptyProducts = Object.keys(allProducts).filter(keyName => {
//                    let currentValue = allProducts[keyName];
//                    return currentValue.availableCount < 1
//                });
//
//                if(emptyProducts.length == Object.keys(allProducts).length) {
//                    this.$router.push({ path: `/sold-out` })
//                } else {
//                    this.$router.push({ path: `/selection` })
//                }

            }
        }
    }

</script>